<template>
  <WdsAvatarLabel class="user-name-column" truncated :data-test="`user-name-${rowIndex}`">
    <template #avatar>
      <AvatarWithFallback :id="user.id" :avatar="user.avatar" />
    </template>
    <WdsText primary class="tw-pl-1" :text="user.name" />
  </WdsAvatarLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import AvatarWithFallback from '@/components/AvatarWithFallback.vue'

const UserNameColumn = graphql(`
  fragment UserNameColumn on User {
    id
    name
    avatar
  }
`)

const props = defineProps<{
  row: FragmentType<typeof UserNameColumn>
  rowIndex?: number
}>()

const user = computed(() => useFragment(UserNameColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
</script>
